import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  // Tag uploads with the project code (from the URL) so the backend files
  // them straight into the project's S3 folder.
  const url = config.url || "";
  if ((url === "/upload" || url === "/upload/chunk") && config.data instanceof FormData
      && !config.data.has("project_code")) {
    const m = window.location.pathname.match(/\/projects\/([^/]+)/);
    if (m) config.data.append("project_code", decodeURIComponent(m[1]));
  }
  return config;
});

export default api;

export function fmtErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
